(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-purchase-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const steps = [...root.querySelectorAll('[data-step]')];
      const dots = [...root.querySelectorAll('[data-go]')];
      const fill = root.querySelector('.nbcg__progress-fill');
      let current = 1;
      let timer;
      const show = number => {
        current = number;
        steps.forEach((item, index) => {
          const active = index + 1 === number;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
        });
        dots.forEach((item, index) => item.classList.toggle('is-active', index + 1 === number));
        fill.style.width = `${number * 25}%`;
      };
      const play = () => {
        clearInterval(timer);
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(current === 4 ? 1 : current + 1), 2300);
      };
      [...steps, ...dots].forEach(item => item.addEventListener('click', () => {
        show(Number(item.dataset.step || item.dataset.go));
        play();
      }));
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', play);
      show(1);
      play();
    };
    const initAll = scope => scope.querySelectorAll('[data-course-guide]').forEach(init);
    initAll(document);
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
